import { Link, Typography } from '@mui/material';

export const ExampleDownload = () => {
  const fileContents = 'firstName,lastName,email';
  const file = new Blob([fileContents], { type: 'text/plain' });

  return (
    <Typography mb={2}>
      Not sure if your file is supported?&nbsp;
      <Link
        download='proctorfree-users-upload-template.csv'
        target='_blank'
        rel='noreferrer'
        href={URL.createObjectURL(file)}
      >
        Click to download
      </Link>
      &nbsp;CSV example
    </Typography>
  );
};
